// extracted by mini-css-extract-plugin
export default {"cls1":"TransactionReportForm-FieldGrid_cls1__qo+Ka","cls2":"TransactionReportForm-FieldGrid_cls2__ITin8 TransactionReportForm-FieldGrid_cls1__qo+Ka"};